/**
 * Begin Again Guide — Crisis / emergency-language detection.
 *
 * Detects a conservative set of phrases suggesting immediate danger,
 * self-harm, or medical/mental-health emergency. When triggered, the widget
 * stops normal navigation and shows a compassionate safety screen that
 * (a) confirms the visitor's country before showing US-specific numbers, and
 * (b) directs them to appropriate immediate help rather than counseling.
 *
 * Detection is intentionally simple keyword matching — the goal is to catch
 * clear signals and route to real help, not to attempt clinical assessment.
 */

const CRISIS_PATTERNS = [
  // suicide / self-harm
  /\bsuicide\b/i,
  /\bsuicidal\b/i,
  /\bkill(?:ing)?\s+my\s*self\b/i,
  /\bwant(?:ing)?\s+to\s+die\b/i,
  /\bwanna\s+die\b/i,
  /\bend(?:ing)?\s+my\s+life\b/i,
  /\bend\s+it\s+all\b/i,
  /\bhurt(?:ing)?\s+my\s*self\b/i,
  /\bharm(?:ing)?\s+my\s*self\b/i,
  /\bself[-\s]?harm\b/i,
  /\bcut(?:ting)?\s+my\s*self\b/i,
  /\boverdose\b/i,
  /\bod\s+on\b/i,
  /\bcan['’]?t\s+go\s+on\b/i,
  /\bno\s+reason\s+to\s+live\b/i,
  // violence
  /\bgoing\s+to\s+kill\b/i,
  /\bkill\s+(?:him|her|them)\b/i,
  /\bhurt\s+(?:him|her|them|someone)\b/i,
  /\bshoot(?:ing)?\s+(?:up|him|her)\b/i,
  // medical emergency
  /\bheart\s+attack\b/i,
  /\bstroke\b/i,
  /\bbleeding\s+out\b/i,
  /\bcan['’]?t\s+breathe\b/i,
  /\bnot\s+breathing\b/i,
  /\bunconscious\b/i,
  /\boverdosing\b/i,
  /\bemergency\b/i,
];

export function isCrisisMessage(text) {
  if (!text) return false;
  return CRISIS_PATTERNS.some((re) => re.test(text));
}
